module.exports = __webpack_public_path__ + "img/12.c318ccf3.jpg";